export default __webpack_public_path__ + "static/media/true_sumes_b_eng.c54f07b1.png";